import { Device, InstallationFormModel } from 'src/Libs/flow/installation/forms'
import { Meter } from '../types'
import { MeterDto } from './types'
import { getUuid } from 'src/Libs/flow/utils'
import { getMeterPairingId, getMeterSerialNumber } from '../utils/get-meter-parameters'
import { getDeviceIsPaired, getDeviceStatus } from 'src/Libs/flow/parsers'

export const fromMeterDtoToModel = (meter: Nullable<MeterDto>): Meter => {
  return {
    ...fromMonitoringMeterDeviceDtoToModel(meter),

    deviceType: meter.deviceType ?? 'HVAC',
    peakPower: meter.deviceType === 'PVExtern' ? meter.typeParameters?.peakPower ?? 0 : null,
    wiringMode: meter.wiringMode ?? 'Normal',
  }
}

export const fromMonitoringMeterDeviceDtoToModel = (meter: Nullable<MeterDto>): Device => {
  return {
    id: getUuid(),
    isNew: false,
    deviceId: `${meter.id ?? ''}`,
    navigationId: `${meter.id ?? ''}`,
    name: meter.deviceName ?? '',
    deviceCategory: 'Meter',
    pairingId: getMeterPairingId(meter),
    serialNumber: getMeterSerialNumber(meter),
    deviceStatus: getDeviceStatus(meter.pairingState, meter.deviceStatus),
    isPaired: getDeviceIsPaired(meter.pairingState),
    deviceStatusCodeBits: meter.deviceStatusCode,
  }
}

export const fromEvseMidMeterToModel = (
  useMidMeter: boolean | null | undefined,
  pulseWeight: number | null | undefined
): InstallationFormModel['chargingStations']['modbusTcp'][number]['midMeter'] => {
  const EVSE_ECP140D_PULSE_WEIGHT = 1
  const EVSE_ECP380D_PULSE_WEIGHT = 5

  if (useMidMeter && pulseWeight === EVSE_ECP140D_PULSE_WEIGHT) return 'ECP140D'
  if (useMidMeter && pulseWeight === EVSE_ECP380D_PULSE_WEIGHT) return 'ECP380D'
  return 'no mid meter'
}
